var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getIsShowPopupSubmitReport
    ? _c(
        "div",
        {
          staticClass: "modal fade",
          class: [
            "modal fade",
            {
              show: _vm.getIsShowPopupSubmitReport,
              "d-block": _vm.getIsShowPopupSubmitReport,
            },
          ],
          staticStyle: { display: "block", "overflow-y": "scroll" },
          attrs: {
            id: "go-submit-report",
            "data-backdrop": "static",
            tabindex: "-1",
            "aria-hidden": "true",
          },
        },
        [
          _vm.language == "ko"
            ? _c(
                "div",
                {
                  staticClass: "modal-dialog go-modal-event",
                  staticStyle: { "max-width": "700px" },
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "go-block-body" }, [
                        _c("p", { staticClass: "lead" }, [
                          _c("strong", [
                            _vm._v(
                              '"' + _vm._s(_vm.getSelectedResource.title) + '"'
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "구버 AI 메이커톤에 이 리포트를 제출하시겠습니까?\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(0),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: { click: _vm.handleCloseModal },
                        },
                        [_vm._v("취소")]
                      ),
                      _vm._v(" "),
                      _vm.isButtonVisible
                        ? _c(
                            "button",
                            {
                              staticClass: "btn go-btn-primary",
                              attrs: { type: "button" },
                              on: { click: _vm.submitReport },
                            },
                            [_vm._v("리포트 제출하기")]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              )
            : _c(
                "div",
                {
                  staticClass: "modal-dialog go-modal-event",
                  staticStyle: { "max-width": "700px" },
                },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-body" }, [
                      _c("div", { staticClass: "go-block-body" }, [
                        _c("p", { staticClass: "lead" }, [
                          _c("strong", [
                            _vm._v(
                              '"' + _vm._s(_vm.getSelectedResource.title) + '"'
                            ),
                          ]),
                          _c("br"),
                          _vm._v(
                            "Ready to submit this report to the Goover AI Makerthon?\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _vm._m(1),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-footer" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn go-btn-default",
                          attrs: { type: "button", "data-dismiss": "modal" },
                          on: { click: _vm.handleCloseModal },
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _vm.isButtonVisible
                        ? _c(
                            "button",
                            {
                              staticClass: "btn go-btn-primary",
                              attrs: { type: "button" },
                              on: { click: _vm.submitReport },
                            },
                            [_vm._v("Submit Report")]
                          )
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-info-box" }, [
      _c("strong", { staticClass: "go-info-title" }, [
        _c("i", { staticClass: "go-icon-24 go-icon-alert-warning" }),
        _vm._v("이벤트 주의사항 안내 "),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "go-info-list" }, [
        _c("li", { staticClass: "go-list-item" }, [
          _c("strong", [_vm._v("참여 기간 : 11월 11일 ~ 12월 14일")]),
          _c("br"),
          _vm._v(
            "리포트 제출은 이벤트 기간인 11월 11일 오전 9시부터 12월 14일 자정\n                (한국 시간 기준) 까지 가능합니다. 제출 기간이 마감되면 참가신청 접수가 되지 않습니다.\n              "
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-list-item" }, [
          _c("strong", [_vm._v("제출 제한 :")]),
          _vm._v(
            " 메이커톤 참가자는 하나의 리포트로만 참여하실 수 있습니다. 제출 회수에는 제한이 없으나\n                "
          ),
          _c("u", [
            _vm._v("마지막으로 제출한 리포트만 대회 참여로 간주됩니다."),
          ]),
          _vm._v(
            " 여러 번 제출하시는 경우에는 앞서 제출하신 리포트는 자동으로 참가\n                취소 됩니다.\n              "
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-list-item" }, [
          _c("strong", [_vm._v("후보 선정 및 투표 :")]),
          _vm._v(
            " 패널 투표를 통해 10개의 최종 후보작이 선정되며, 최종 후보들은 사용자 투표로\n                결정됩니다.\n              "
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-list-item" }, [
          _c("strong", [_vm._v("수상자 발표 :")]),
          _vm._v(
            " 최종 수상자는 12월 중으로 발표되며, 수상에 관련해서는 구버에 등록된 연락처를 통해 개별 안내\n                드립니다.\n              "
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "go-info-box" }, [
      _c("strong", { staticClass: "go-info-title" }, [
        _c("i", { staticClass: "go-icon-24 go-icon-alert-warning" }),
        _vm._v("Makerthon Participation Guidelines "),
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "go-info-list" }, [
        _c("li", { staticClass: "go-list-item" }, [
          _c("strong", [_vm._v("Event Dates : November 11 – December 14")]),
          _c("br"),
          _vm._v(
            "You can submit your report starting from 9:00 AM on November\n                11 until midnight on December 14 (KST). Submissions will not be accepted once the deadline has passed.\n              "
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-list-item" }, [
          _c("strong", [_vm._v("Submission Rules :")]),
          _vm._v(" "),
          _c("u", [
            _vm._v(
              "Each participant is allowed to submit one report for consideration."
            ),
          ]),
          _vm._v(
            " While you\n                may resubmit multiple times, only the last submission will be reviewed, with prior submissions automatically disregarded.\n              "
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-list-item" }, [
          _c("strong", [_vm._v("Finalists & Voting :")]),
          _vm._v(
            " A panel will select the top 10 entries, after which the finalists will be put to a\n                public vote.\n              "
          ),
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "go-list-item" }, [
          _c("strong", [_vm._v("Winner Announcement :")]),
          _vm._v(
            " Final winners will be announced on December, with individual notifications sent to\n                the contact information on Goover.\n              "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }